module.exports = __webpack_public_path__ + "static/media/Approve-icon.010009cf.svg";